import React from 'react';

export default function CompanyMessages(props) {
    return (
        <div className="incoming_msg">
            <div className="incoming_msg_img">
                <img src="https://ptetutorials.com/images/user-profile.png" alt="sunil" />
            </div>
            <div className="received_msg">
                <div className="received_withd_msg">
                    <p>{props.message.userMessage}</p>
                    <span className="time_date">{props.message.time}</span>
                </div>
            </div>
        </div>
    )
}
